<section class="mt-2" >
  <div *ngIf="studium.zapisneListy" matBadge="{{studium.zapisneListy.length}}" matBadgeColor="warn" matBadgeOverlap="false" matBadgePosition="after"></div>
  <mat-expansion-panel [(expanded)]="show">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6 text-nowrap" i18n>Zápisné listy</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="studium.zapisneListy">
      <app-zapisny-list *ngFor="let zl of studium.zapisneListy" [zapisnyList]="zl"></app-zapisny-list>
    </div>

    <section *ngIf="studium.zapisnyListNext">

        <hr/>

        <div class="d-flex flex-row justify-content-start">

          <div *ngIf="studium.zapisnyListNext.ezapis" >
            <b>
              <a (click)="vytvoritElektronickyZapis()" i18n-title title="Vytvoriť zápisný list">
                <span i18n>Môj zápis v akademickom roku</span> {{studium.zapisnyListNext.akRok}}<sup class="material-icons small">open_in_new</sup>
              </a>
            </b>
          </div>

          <div *ngIf="!studium.zapisnyListNext.ezapis" class="me-3">
            <b>
              <a (click)="vytvoritZapisnyList()" i18n-title title="Vytvoriť zápisný list">
                <span i18n>Môj zápis v akademickom roku</span> {{studium.zapisnyListNext.akRok}}
              </a>
            </b>
          </div>

        </div>

    </section>

  </mat-expansion-panel>
</section>
